export default __webpack_public_path__ + "static/collab-4dadb85150b0c6b4575192195dec2a40.svg";